import type { ComponentRegistry } from '@vibesites/runtime';

export const registry: ComponentRegistry = {};

export default registry;
